<template>
  <div class="container">
    <div class='reload'>
      <el-breadcrumb separator="/">
        <span class="leftLine"></span>
        <el-breadcrumb-item>代理商结算管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-arrow-left"
                 size="mini"
                 @click="$router.back()">返回</el-button>
    </div>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="formBox">
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   label-position="left"
                   style="padding:20px;background:#fff"
                   label-width="180px">
            <el-row :gutter="60">
              <el-col :span="12">
                <el-form-item label="结算日期："
                              required>
                  <el-date-picker v-model="form.settleDate"
                                  type="date"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实际购电价格(元)：">
                  <el-input v-model="form.actualPowerPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="序号：">
                  <el-input v-model="form.serialNumber"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公司收益(含代理费)：">
                  <el-input v-model="form.companuProfit" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区域："
                              required>
                  <el-select v-model="form.areaName"
                             filterable
                             clearable
                             placeholder="请选择区域">
                    <el-option v-for="item in provinces"
                               :key="item.code"
                               :label="item.name"
                               :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="基准购电价格(元)：">
                  <el-input v-model="form.basicPowerPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="客户名称："
                              required>
<!--
                  <el-input v-model="form.clientName"></el-input>
-->
                  <el-select v-model="form.clientName"
                             @change="changeClientName"
                             filterable
                             clearable
                             placeholder="请选择">
                    <el-option v-for="item in clientNames"
                               :key="item.clientId"
                               :label="item.clientName"
                               :value="item.clientName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="公司差价(元)：">
                  <el-input v-model="form.companyPriceDiff" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label=" 合同比例(%)：">
                  <el-input v-model="form.contractRatio" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="代理收益比例(%)：">
                  <el-input v-model="form.agentProfitRatio" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="实际用电量(kW·h)：">
                  <el-input v-model="form.actualElectric" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="代理费(元)：">
                  <el-input v-model="form.agentFee" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="公司收益比例(%)：">
                  <el-input v-model="form.compayProfitRatio" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公司收益：">
                  <el-input v-model="form.companyActualProfit" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="企业结算价格(元)：">
                  <el-input v-model="form.companySettlePrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="一级代理费：">
                  <el-input v-model="form.firstAgentFee" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上报结算价格(元)：">
                  <el-input v-model="form.reportSettlePrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商：">
                  <el-input v-model="form.agent"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="实际结算价格(元)：">
                  <el-input v-model="form.actualSettlePrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="ax_default line1"></div>
            <el-form-item>
              <div style="text-align:center">
                <el-button style="margin-righr:60px"
                           @click="$router.back()">取消</el-button>
                <el-button @click="submitForm('form')"
                           type="primary">保存</el-button>
              </div>

            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {getprovince, postsettleAgent, putsettleAgent, getclientNames, getClientInfoVO} from '../../API'
export default {
  data () {
    return {
      activeIndex: this.$route.path,
      form: {
        actualElectric: '',
        actualPowerPrice: '',
        actualSettlePrice: '',
        agent: "",
        agentFee: '',
        agentProfitRatio: '',
        areaCode: "",
        areaName: "",
        basicPowerPrice: '',
        clientId: '',
        clientName: "",
        companuProfit: "",
        companyActualProfit: '',
        companyPriceDiff: '',
        companySettlePrice: '',
        compayProfitRatio: '',
        contractId: '',
        contractRatio: '',
        firstAgentFee: '',
        reportSettlePrice: '',
        serialNumber: '',
        settleAgentId: '',
        settleDate: "",
      },
      name: '新增',
      clientNames: [],
      provinces: []
    }
  },
  created () {
    if (localStorage.getItem('dlsjs')) {
      this.form = JSON.parse(localStorage.getItem('dlsjs'))
      this.name = "修改"
    }
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinces = res.data
      }
    })
    getclientNames().then(res => {
        if (res.code === 0) {
            this.clientNames = res.data
        }
    })
  },
  methods: {
    changeClientName(data) {
      let resultArr = this.clientNames.filter((item) =>{
          return item.clientName === data
      });
      // 判断数组是否为空
      if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
          return;
      }
      this.form.clientId = resultArr[0].clientId
      getClientInfoVO(resultArr[0].clientId).then(res => {
          if (res.code == 0) {
              this.form.saleId = res.data.saleId;
              this.form.saleName = res.data.saleName;
              this.form.agentId = res.data.agentId;
              this.form.agentName = res.data.agentName;
              this.form.contractId = res.data.contractId;
              // this.contractName = res.data.contractName;
          }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('dlsjs')) {
            this.form.clientId = localStorage.getItem('id')
            putsettleAgent(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
              }
            })

          }
          else {
            postsettleAgent(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.reload {
  background-color: rgba(236, 240, 245, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header {
  height: 50px;
  line-height: 50px;
  background: rgb(243, 243, 243);
  padding: 0 20px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
.formBox {
  border: 1px solid #e4e4e4;
  border-top: 7px solid #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}

.form {
  background-color: #fff;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 20px;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line1 {
  height: 1px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
}
/deep/ .el-input{
    width: 200px;
  }
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>
